import * as React from 'react';
import * as Styled from './FaqItem.styled';
import { useDimensions } from '../../hooks/useDimensions';
import { useMemoizedHTML } from '../../hooks/useMemoizedHTML';
import { KeyboardArrowDown } from '../../svgs';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const FaqItem = ({
  question,
  answer,
  faqId
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const containerRef = React.useRef(null);
  const [contentRef, {
    height
  }] = useDimensions();
  React.useEffect(() => {
    if (!containerRef.current) {
      return;
    }
    containerRef.current.style.height = `${isOpen ? height : 0}px`;
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Styled.FaqItem, {
      "data-id": "cp-faq-toggle",
      role: "button",
      tabIndex: 0,
      onClick: () => setIsOpen(!isOpen),
      onKeyDown: e => (e.key === 'Enter' || e.key === ' ') && setIsOpen(!isOpen),
      "aria-expanded": isOpen ? 'true' : 'false',
      "aria-controls": `faq-${faqId}`,
      isOpen: isOpen,
      id: `faq-${faqId}-title`,
      children: [/*#__PURE__*/_jsx(Styled.Question, {
        dangerouslySetInnerHTML: useMemoizedHTML(question)
      }), /*#__PURE__*/_jsx(KeyboardArrowDown, {})]
    }), /*#__PURE__*/_jsx(Styled.Answer, {
      ref: containerRef,
      "aria-hidden": !isOpen,
      children: /*#__PURE__*/_jsx("p", {
        ref: contentRef,
        id: `faq-${faqId}`,
        role: "region",
        "aria-live": "polite",
        dangerouslySetInnerHTML: useMemoizedHTML(answer)
      })
    })]
  });
};